let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6rwKJ")).then(() => parcelRequire('2NbdJ'));